import { render, staticRenderFns } from "./FormDiscount.vue?vue&type=template&id=13a39887&"
import script from "./FormDiscount.vue?vue&type=script&lang=js&"
export * from "./FormDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports